import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'
import { NameMode } from '@/enum/NameMode'

const senderNameModeDict: Array<Dictionary> = []

for (const code of
    [
        NameMode.none,
        NameMode.legalName,
        NameMode.storeName,
        NameMode.warehouseName,
        NameMode.custom
    ]
) {
    senderNameModeDict.push({
        code: code,
        name: i18n.t(`dictionary.senderNameMode.${code}`).toString()
    })
}

export { senderNameModeDict }
